import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

import Header from './components/Header';
import HeroCarousel from './components/HeroCarousel'; // ✅ NEW component
import About from './components/About';
import Blog from './components/Blog';
import HealthyUdder from './components/HealthyUdder';
import Contact from './components/Contact';
import CTA from './components/CTA';
import ScrollTopButton from './components/ScrollTopButton';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000,});
  }, []);
  window.addEventListener("load", () => {
  document.body.classList.add("font-loaded");
});
useEffect(() => {
  document.title = 'AK Technologies';
}, []);


  return (
    <>
      <Header />
      <main>
        {/* ✅ New Hero Carousel Section */}
        <HeroCarousel />

        <About />
        <Blog />
        <HealthyUdder />
        <CTA />
        <Contact />
        <ScrollTopButton />
        <Footer />
      </main>
    </>
  );
}

export default App;
